import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import logo from "../../../assets/img/logo-mini.png";
import './Launching.css';

const Launching = () => {
    const navigate = useNavigate();
    const [isExiting, setIsExiting] = useState(false);

    const handleLaunch = () => {
        setIsExiting(true);
        // Wait for animation to finish before navigating
        setTimeout(() => {
            navigate('/home');
        }, 1000); // Matches the 3s animation duration in CSS
    };

    return (
        <div className={`launching-container ${isExiting ? 'exit' : ''}`}>
            <div className={`launching-content`}>
                {/* <img src={logo} alt="BEC Logo" className="launching-logo" /> */}
                {/* <h1 className="launching-title">Official Launch of Our New Initiative</h1> */}
                {/* <p className="launching-subtitle">With great enthusiasm, we introduce our newly launched platform aimed at strengthening connections and creating impactful experiences. This launch represents our dedication to excellence, collaboration, and continuous growth within our community.</p> */}
                <button className="launch-btn" onClick={handleLaunch}>
                    Get Started
                </button>
            </div>
        </div>
    );
};

export default Launching;
